import { useCallback, useState } from 'react';
import SimpleDropdown from '../../../../../components/grid/ag/cellEditor/SimpleDropdown';
import AgGridNew from '../../../../../components/grid/ag/ag-grid-new';
import { getLabelFromDropdown, getNewValue, gridLinkValueFormat } from '../../../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import axios from 'axios';
import Helper from '../../../../../inc/Helper';
import { connect } from 'react-redux';
import Settings from '../../../../../inc/Settings';
import { getPopupMessageBasedOnStatus, commonThousandSeparator } from '../../../../../inc/Validation';
import ConditionalDataPopup from './ConditionalDataPopup';
import Api from '../../../../../inc/Api';

let gridApi = null;
const ConditionalWorkflowModule = ({ language, nodeLabel, onConditionalModalClose, save, nodeDeleteHandler, addNode, actionValue, hideConditionalModal, mainModal, currentHandleId, currentNode, checkInstance, workflowBodyId, onClickNode, fieldDictionaryData }) => {
    const [popupDetails, setPopupDetails] = useState({});
    const [existingConditions, setExistingConditions] = useState([]);
    const [showCreateModal, setShowCreateModal] = useState(false); 

    const onDeleteConditions = useCallback(async (element) => {
        const value = await checkInstance();
        if (value) {
            Helper.alert("This workflow have instance, so you can't delete", 'error');
            return;
        };

        let delete_condition_id = element?.data?.condition_id;
        const formData = { node_id: onClickNode, condition_id: [delete_condition_id] };

        try {
            let api = Api;
            api.setUserToken();
            const res = await
                api.axios()
                .post(Settings.baseUrl + 'workflow-condition/delete', formData)
            const rowNode = gridApi?.api?.getRowNode(delete_condition_id);

            if (rowNode) {
                rowNode.setSelected(false)
            };

            if (existingConditions?.some(item => (item.condition_id) == (delete_condition_id) && (item.clause) == 1)){
                nodeDeleteHandler();
            };

            setTimeout(() => {
                const transaction = { remove: [element.data] }
                gridApi?.api?.applyServerSideTransaction(transaction)
            }, 200);

            gridApi?.api?.refreshServerSide({ purge: true });
            gridApi?.api?.deselectAll();

            Helper.alert(res.data.message, 'success');
        } catch (err) {
            getPopupMessageBasedOnStatus(err)
        };
    }, [existingConditions]);

    const onAddBtnClick = () => {
        if(!onClickNode && nodeLabel === ''){
            Helper.alert('Label is required', 'error');
            return;
        };
        setShowCreateModal(true); 
        setPopupDetails({});
    };

    const onGridCellClicked = (event) => {   
        if(event.colDef.field === 'clause') {
            setPopupDetails(event?.data);
            setShowCreateModal(true); 
        };
    };

    const reloadGrid = () => {
        gridApi?.api?.refreshServerSide({ purge: true })
        gridApi?.api?.deselectAll();
    };

    const handleFetchData = (response) => {
        if(response?.data?.data) {
            setExistingConditions(response?.data?.data);
        }
        return {
            rowData: response?.data?.data?.map((item) => ({
                ...item,
                gridId: `${Date.now()}_${getNewValue()}`,
            })),
            rowCount: response?.data?.data?.length || 0
        }
    };
    
    /* Grid Column Headers */

    const gridColumnHeaders = [
        {
            field: 'clause',
            valueGetter: (params) => {
                const { label } = Settings.conditionData?.find(obj => obj.value == params?.data?.clause);
                return label ?? '';
            },
            headerName: Helper.getLabel(language,'clause','Clause'),
            editable: false,  
            minWidth: 180,  
            inputId: 'clause_id',
            filter: false,
            cellRenderer: gridLinkValueFormat,
            sortable: false
        },
        {
            field: 'field_id', 
            headerName: Helper.getLabel(language,'field_id','Field'),
            editable: false,
            cellEditor: SimpleDropdown,
            isAllowZero:true,
            minWidth:180, 
            cellEditorParams: {
                values: fieldDictionaryData?.map(item => {
                    return {
                        value: item.field_id,
                        label: item.field_label
                    }
                })
            },
            cellDataType:false,
            valueFormatter: (params)=> getLabelFromDropdown(params),
            filter: false,
            sortable: false
        },
        {
            field: 'operator',
            headerName: Helper.getLabel(language,'operator','Operator'),
            editable: false,
            cellEditor: SimpleDropdown,
            isAllowZero:true,
            minWidth:180, 
            cellEditorParams: {
                values: Settings.operatorData 
            },
            cellDataType:false,
            valueFormatter: (params)=> getLabelFromDropdown(params),
            filter: false,
            sortable: false
        },
        {
            field: 'value',
            valueFormatter: (params) => {
                return params.value ? commonThousandSeparator(params.value) : "-"
            },
            headerName: Helper.getLabel(language,'value','Value'),
            editable: false
        }
    ];
    return (
        <>
            { !showCreateModal ? null : 
                <ConditionalDataPopup 
                    popupDetails={popupDetails}
                    setPopupDetails={setPopupDetails}
                    nodeLabel={nodeLabel}
                    fieldDictionaryData={fieldDictionaryData} 
                    reloadParentGrid={reloadGrid} 
                    existingConditions={existingConditions}
                    setShowCreateModal={setShowCreateModal}
                    workflowBodyId={workflowBodyId}
                    checkInstance={checkInstance}
                    currentNode={currentNode}
                    onClickNode={onClickNode}
                    currentHandleId={currentHandleId}
                    save={save} 
                    addNode={addNode} 
                    actionValue={actionValue} 
                    hideConditionalModal={hideConditionalModal} 
                    mainModal={mainModal}
                    onConditionalModalClose={onConditionalModalClose}
                /> 
            }

            <AgGridNew 
                apiUrl={Settings.baseUrl + `workflow-condition/get?body_id=${workflowBodyId}&node_id=${onClickNode}`}
                returnApiCondition={!workflowBodyId || !onClickNode}
                pagination={false}
                apiTokenRequired={false}
                onCellClicked={onGridCellClicked}
                fetchData={handleFetchData}
                onAddClick={onAddBtnClick}
                handleDeleteSelectedRows={onDeleteConditions}
                columnDefs={gridColumnHeaders}
                onGridReady={(params) => gridApi = params}
                height={500}
                uniqueField={'condition_id'}
                gridId={'rs_conditional_workflow'}
            />
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        language:state.language
    }
}

export default connect(mapStateToProps) (ConditionalWorkflowModule);